import React, { Component } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import plan from '../../assets/img/premium/plan.svg'
import close from '../../assets/img/icons/close.svg'
import { Redirect } from 'react-router-dom'
import axios from 'axios';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class SuperLikePlan extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedOption: '',
            boost_Count: '',
            superactivatemodal: false,
            api_url:localStorage.getItem('api_url'),
            boostItems: [],
            coupon_type: 'boost',
        };
    }

    componentDidMount() {
        console.log("Current premium type:", this.props.premiumType);

        var premiumlist = new FormData();
        premiumlist.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        premiumlist.append('platform', 'web');
        premiumlist.append('language', this.state.langKey); 

        axios({
            method: 'post', 
            url: this.state.api_url+'webboostlist', 
            data: premiumlist,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status === "true") {
                const data = res.data; 
                this.setState({
                    boostItems: data.result,
                    activeItem: data.result[0].id,
                    selected_boostpremium: data.result[0].id,
                    boostpremium_price: data.result[0].price,
                    currency: data.currency,
                    payment: data.payment,
                    license_key: data.license_key,
                    boostPlanStatus: 1,
                    boost_Count: data.boost_count, 
                    original_price: data.result[0].price,
                    discount_price: 0,
                    total_price: data.result[0].price,
                });
            } 
        }) .catch(error => console.error('Error fetching premium list:', error));
    }

    handleItemClick(index) {
        var premiumboostlist = new FormData();
        premiumboostlist.set('premiumboostid', index);
        premiumboostlist.set('language', this.state.langKey); 
        
        axios({
            method: 'post',
            url: this.state.api_url+'premiumboostid',
            data: premiumboostlist, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const data = res.data;
            this.setState({
                boostpremium_price: data.result.price,
                original_price: data.result.price,
                discount_price: 0,
                total_price: data.result.price,
                boost_Count: data.result.boost_count,
            });
            localStorage.setItem('selected_premium',JSON.stringify(index));
            localStorage.setItem('premium_price',JSON.stringify(data.result.price)); 
            localStorage.setItem('discount_id',JSON.stringify(0)); 
            localStorage.setItem('original_price',JSON.stringify(data.result.price));
            localStorage.setItem('discount_price',JSON.stringify(0));
            localStorage.setItem('total_price',JSON.stringify(data.result.price));  
        });   

    }

    handleOptionChange = (packageId) => {
        this.setState({
            selectedOption: packageId
        });
        this.handleItemClick(packageId);
    };

    handleSuperActivateOpenModal = () => {
        if(this.state.selectedOption === null || this.state.selectedOption === '') {
            this.setState({ noboostplan: 'Please select any one plan' });
            setTimeout(() => {
                this.setState({
                    noboostplan: ''
                });
            }, 2000);
        } else {
            this.props.handleClose();
            this.setState({ couponmodal: true });
        }
    }

    render() {

        if (this.state.couponmodal) {
            const premiumPath = `/coupon/${this.state.coupon_type}`;
            return <Redirect to={premiumPath} />;
        }

        const checkedRadioStyle = {
            color: '#fff',
        };

        return (
            <>
                <div className="">
                    <Modal className="modal_div joinplan_modal" show={this.props.showModal} onHide={this.props.handleClose} centered>
                        <Modal.Header>
                            <Button className="close" onClick={this.props.handleClose}>
                                <img src={close} alt="img" style={{marginBottom:"10px"}}/>
                            </Button>
                        </Modal.Header>
                        <Modal.Body className="religion_modal selectplan_height">
                            <div className=''>
                                <div className='superactivateplan_img'>
                                    <img src={plan} alt="img" />
                                </div>
                                <div className='selectplan_content'>
                                    <h4><Trans i18nKey="Out of Boost">Out of Boost</Trans></h4>
                                    <p><Trans i18nKey="Giving a boost is a way to tell someone that you're interested in them">Giving a boost is a way to tell someone that you're interested in them</Trans></p>
                                </div>
                                <div className='selectplan_select'>
                                    {this.state.boostItems.map((item, index) => (
                                        <Form.Group key={index} controlId={`premiumOption-${index}`} className={`language_formgroup selectplan_formgroup selectplaninput ${this.state.selectedOption === item.id ? 'common_language' : ''}`}>
                                            <Form.Check.Label htmlFor={`radio-${item.id}`}>
                                                <span style={this.state.selectedOption === item.id ? checkedRadioStyle : null}>
                                                    {this.state.currency}{item.price} <Trans i18nKey="for">for</Trans> {item.boost_count} <Trans i18nKey="Boosts">Boosts</Trans>
                                                </span>
                                            </Form.Check.Label>
                                            <Form.Check
                                                type="radio"
                                                id={`radio-${item.id}`}
                                                name="radioGroup"
                                                value={item.id}
                                                checked={this.state.selectedOption === item.id}
                                                onChange={() => this.handleOptionChange(item.id)}
                                            />
                                        </Form.Group>
                                    ))}
                                </div>
                            </div>
                        </Modal.Body>
                        <div className="errorMsg" style={{ paddingLeft: "135px" }}>{this.state.noboostplan}</div>
                        <Modal.Footer className="forgot_button_plr">
                            <Button className='button_primary' onClick={this.handleSuperActivateOpenModal}>
                            <Trans i18nKey="BUY">BUY</Trans> {this.state.boost_Count} <Trans i18nKey="Boost">Boost</Trans>
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </>
        );
    }
}

export default SuperLikePlan;
